import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from "../ui/sheet";
import { Button } from "../ui/button";
import { RotateCcw } from "lucide-react";

const FilterChip = ({ label, active, onClick, testId }) => (
  <button
    onClick={onClick}
    className={`px-4 py-2 rounded-full text-sm font-semibold transition-all border ${
      active
        ? "bg-gray-900 text-white border-gray-900"
        : "bg-white text-gray-700 border-gray-200 hover:border-gray-400"
    }`}
    data-testid={testId}
  >
    {label}
  </button>
);

/**
 * Bottom sheet con TUTTI i filtri condensati: scadenza, categoria, ordinamento.
 */
const FiltersBottomSheet = ({
  open, onOpenChange,
  filterGiorni, setFilterGiorni,
  filterCategoria, setFilterCategoria,
  sortBy, setSortBy,
  categorieUsate = [],
}) => {
  const reset = () => {
    setFilterGiorni(null);
    setFilterCategoria(null);
    setSortBy("scadenza");
  };

  const activeCount = (filterGiorni !== null ? 1 : 0) + (filterCategoria ? 1 : 0) + (sortBy !== "scadenza" ? 1 : 0);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="rounded-t-3xl max-h-[85vh] overflow-y-auto" data-testid="filters-sheet">
        <SheetHeader>
          <SheetTitle className="text-xl font-extrabold tracking-tight">
            Filtri {activeCount > 0 && <span className="text-sm font-medium text-gray-500 ml-2">({activeCount} attivi)</span>}
          </SheetTitle>
        </SheetHeader>

        <div className="space-y-6 py-4">
          {/* Scadenza */}
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-3">Scadenza</p>
            <div className="flex flex-wrap gap-2">
              <FilterChip label="Tutti" active={filterGiorni === null} onClick={() => setFilterGiorni(null)} testId="sheet-filter-tutti" />
              {[7, 14, 30].map((g) => (
                <FilterChip key={g} label={`Entro ${g}gg`} active={filterGiorni === g} onClick={() => setFilterGiorni(g)} testId={`sheet-filter-${g}`} />
              ))}
            </div>
          </div>

          {/* Categoria */}
          {categorieUsate.length > 0 && (
            <div>
              <p className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-3">Categoria</p>
              <div className="flex flex-wrap gap-2">
                <FilterChip label="Tutte" active={!filterCategoria} onClick={() => setFilterCategoria(null)} testId="sheet-cat-tutte" />
                {categorieUsate.map((cat) => (
                  <FilterChip key={cat} label={cat} active={filterCategoria === cat} onClick={() => setFilterCategoria(cat)} testId={`sheet-cat-${cat}`} />
                ))}
              </div>
            </div>
          )}

          {/* Ordinamento */}
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-3">Ordina per</p>
            <div className="flex flex-wrap gap-2">
              {[
                { key: "scadenza", label: "Scadenza" },
                { key: "creazione", label: "Data creazione" },
                { key: "ricetta", label: "Ricetta" },
              ].map((o) => (
                <FilterChip key={o.key} label={o.label} active={sortBy === o.key} onClick={() => setSortBy(o.key)} testId={`sheet-sort-${o.key}`} />
              ))}
            </div>
          </div>
        </div>

        <SheetFooter className="flex-row gap-2 border-t border-gray-100 pt-4">
          <Button variant="outline" onClick={reset} className="flex-1 gap-2" data-testid="sheet-reset">
            <RotateCcw className="h-4 w-4" /> Reset
          </Button>
          <Button onClick={() => onOpenChange(false)} className="flex-1 bg-gray-900 hover:bg-gray-800 text-white" data-testid="sheet-apply">
            Applica
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};

export default FiltersBottomSheet;
